import { Component, default as React } from "react";
import { Link } from "react-router-dom";

class FailedPage extends Component<any, any> {

	public render() {
		return (
			<div id="page-container">
				<main id="main-container">
					<div className="bg-image" style={{backgroundImage: `url(https://news.craftmania.cz/content/images/size/w2000/2020/02/1904-1024--13-.png)`}}>
						<div className="hero bg-white-90">
							<div className="hero-inner">
								<div className="content content-full">
									<div className="px-3 py-5 text-center">
										<div className="row" data-toggle="appear">
											<div className="col-sm-6 text-center text-sm-right">
												<div className="display-1 text-danger font-w700">404</div>
											</div>
											<div className="col-sm-6 text-center d-sm-flex align-items-sm-center">
												<div className="display-1 text-muted font-w300">Chyba</div>
											</div>
										</div>
										<h1 className="h2 font-w700 mt-5 mb-3" data-toggle="appear"
											data-class="animated fadeInUp" data-timeout="300">Sakra! Víš že hledáš
											stránku, která zde neexistuje?</h1>
										<h2 className="h3 font-w400 text-muted mb-5" data-toggle="appear"
											data-class="animated fadeInUp" data-timeout="450">Nevadí, vždy se můžeš
											vrátit zpět na hlavní stránku.</h2>
										<div className="" data-toggle="appear" data-class="animated fadeInUp" data-timeout="600">
											<Link className="btn btn-hero-secondary" to="/">
												<i className="fa fa-arrow-left mr-1"/> Zpět na hlavní stránku
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</main>
			</div>
		);
	}

}

export default FailedPage;
